import React from "react";

function Testimonials() {
  const FallbackReviews = [
    {
      text: "“Peaceful environment and excellent yoga therapies.”",
      author: "Google Reviewer",
      initials: "G"
    },
    {
      text: "“Natural healing treatments really improved my health.”",
      author: "Google Reviewer",
      initials: "R"
    },
    {
      text: "“Very calm place with caring staff and good service.”",
      author: "Google Reviewer",
      initials: "U"
    }
  ];

  return (
    <section className="bg-gradient-to-b from-white to-green-50 px-4 py-16 sm:px-6 md:px-16 font-poppins min-h-screen flex flex-col justify-center text-neutral-900">
      
      {/* Heading */}
      <div className="text-center mb-10">
        <h2 className="text-4xl md:text-5xl font-black text-green-900 tracking-wide">
          What Our Visitors Say
        </h2>
        <p className="mt-3 text-green-800 font-bold text-base md:text-xl">
          Read real experiences and insights shared by our visitors
        </p>
      </div>

      {/* Rating Badge */}
      <div className="flex justify-center mb-12">
        <div className="bg-white border border-green-100 shadow-xl px-6 py-3 rounded-full text-green-800 font-black text-lg md:text-xl flex items-center gap-2">
          <span className="text-yellow-500 text-2xl">★</span> 
          <span>4.8 / 5 Google Rating</span>
        </div>
      </div>

      {/* Review Cards Grid */}
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 mb-12 w-full">
        {FallbackReviews.map((review, idx) => (
          <div 
            key={idx} 
            className="bg-white p-6 md:p-8 rounded-2xl shadow-xl border border-green-50 flex flex-col justify-between hover:-translate-y-1 transition-all duration-300"
          >
            <div>
              {/* Star Rating Render */}
              <div className="flex text-yellow-500 text-lg mb-4">
                ★★★★★
              </div>
              <p className="text-neutral-800 text-base md:text-lg font-bold leading-relaxed italic">
                {review.text}
              </p>
            </div>

            {/* Profile Placement */}
            <div className="mt-6 flex items-center gap-3 pt-4 border-t border-neutral-100">
              <div className="w-10 h-10 rounded-full bg-green-800 text-white font-black flex items-center justify-center text-sm shadow-inner">
                {review.initials}
              </div>
              <div>
                <h3 className="font-black text-green-900 text-sm md:text-base">
                  {review.author}
                </h3>
                <p className="text-xs text-neutral-400 font-bold">Verified Google User</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Action CTA Button */}
      <div className="text-center">
        <a
          href="https://www.google.com/maps/search/?api=1&query=Universal+Goodlife+Ashram+reviews"
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 bg-green-700 hover:bg-green-800 text-white px-8 py-4 rounded-xl font-black text-base md:text-lg shadow-lg shadow-green-100 transition-all transform active:scale-95"
        >
          <span>🌐</span> View All Google Reviews
        </a>
      </div>

    </section>
  );
}

export default Testimonials;